import { render, staticRenderFns } from "./LohnansatzModal.vue?vue&type=template&id=13363678"
import script from "./LohnansatzModal.vue?vue&type=script&lang=js"
export * from "./LohnansatzModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports